import { COUNTRY_CODES } from "../../../constants/countries";

export const INVOICE_LINES_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        requireAuthorizationForDiscount: () => true, //siempre requiere autorizacion del admin para aplicar descuento en linea
        maxLineDiscount: 100,
        canApplyPriceIncrease: true,
        requireAuthorizationForPriceIncrease: () => true,
    },
    [COUNTRY_CODES.PARAGUAY]: {
        requireAuthorizationForDiscount: () => true,
        maxLineDiscount: 100,
        canApplyPriceIncrease: true,
        requireAuthorizationForPriceIncrease: () => true,
    },
    [COUNTRY_CODES.HONDURAS]: {
        requireAuthorizationForDiscount: (discount) => { return discount >= 27; },
        maxLineDiscount: 50,
        canApplyPriceIncrease: true,
        requireAuthorizationForPriceIncrease: () => true,
    },
    [COUNTRY_CODES.ELSALVADOR]: {
        requireAuthorizationForDiscount: () => true,
        maxLineDiscount: 100,
        canApplyPriceIncrease: true,
        requireAuthorizationForPriceIncrease: () => true,
    },
    [COUNTRY_CODES.PERU]: {
        requireAuthorizationForDiscount: () => true,
        maxLineDiscount: 100,
        canApplyPriceIncrease: true,
        requireAuthorizationForPriceIncrease: () => true,
    },
};

export const getInvoiceLinesConfig = (country) => { return INVOICE_LINES_CONFIG[country] || INVOICE_LINES_CONFIG[COUNTRY_CODES.ECUADOR]; };